import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WebSocketConnectionsService {
  private readonly baseUrl: string = environment.connectionsUrl;

  constructor(
    private readonly http: HttpClient
  ) {
  }

  public onConnected(connectionId: string): Observable<void> {
    const options = {
      headers: new HttpHeaders({'Content-Type': 'application/json'}),
      withCredentials: false
    };
    const payload = {id: connectionId};
    return this.http.post<void>(this.baseUrl, payload, options);
  }
}
